module.exports = __webpack_public_path__ + "media/1200_HC_2023_Social_Media.df8c54b9.mp4";